import React, { useState, useEffect } from 'react';
import api from '../services/api';
import './Customers.css';

function Customers({ onBack }) {
  const [customers, setCustomers] = useState([]);
  const [loading, setLoading] = useState(true);
  const [search, setSearch] = useState('');
  const [selectedCustomer, setSelectedCustomer] = useState(null);
  const [outstanding, setOutstanding] = useState([]);

  useEffect(() => {
    loadCustomers();
  }, []);

  const loadCustomers = async () => {
    try {
      const companyID = localStorage.getItem('companyID');
      const response = await api.getCustomers(companyID);
      setCustomers(response.data.customers || []);
    } catch (err) {
      console.error(err);
    } finally {
      setLoading(false);
    }
  };

  const viewOutstanding = async (customer) => {
    try {
      const companyID = localStorage.getItem('companyID');
      const response = await api.getCustomerOutstanding(customer.customerID, companyID);
      setOutstanding(response.data.invoices || []);
      setSelectedCustomer(customer);
    } catch (err) {
      console.error(err);
    }
  };

  const filteredCustomers = customers.filter(c =>
    c.customerName.toLowerCase().includes(search.toLowerCase()) ||
    c.customerID.toLowerCase().includes(search.toLowerCase())
  );

  if (loading) return <div className="customers-loading">Loading customers...</div>;

  if (selectedCustomer) {
    return (
      <div className="customers-container">
        <div className="customers-header">
          <button className="back-btn" onClick={() => setSelectedCustomer(null)}>← Back</button>
          <h1>Outstanding Invoices</h1>
          <h2>{selectedCustomer.customerName}</h2>
        </div>
        <div className="outstanding-list">
          {outstanding.length === 0 ? (
            <div className="no-outstanding">No outstanding invoices</div>
          ) : (
            outstanding.map(inv => (
              <div key={inv.invoiceNo} className="outstanding-card">
                <div className="outstanding-info">
                  <span className="inv-no">{inv.invoiceNo}</span>
                  <span className="inv-date">{inv.invoiceDate}</span>
                </div>
                <div className="outstanding-amount">
                  <span className="amount-label">Outstanding:</span>
                  <span className="amount-value">RM {inv.outstanding}</span>
                </div>
                {inv.daysOverdue > 0 && (
                  <div className="overdue-badge">{inv.daysOverdue} days overdue</div>
                )}
              </div>
            ))
          )}
        </div>
      </div>
    );
  }

  return (
    <div className="customers-container">
      <div className="customers-header">
        <button className="back-btn" onClick={onBack}>← Back to Dashboard</button>
        <h1>Customers</h1>
      </div>
      <div className="search-bar">
        <input
          type="text"
          placeholder="Search by name or ID..."
          value={search}
          onChange={(e) => setSearch(e.target.value)}
          className="search-input"
        />
      </div>
      <div className="customers-list">
        {filteredCustomers.map(customer => (
          <div key={customer.customerID} className="customer-card" onClick={() => viewOutstanding(customer)}>
            <div className="customer-info">
              <div className="customer-name">{customer.customerName}</div>
              <div className="customer-id">ID: {customer.customerID}</div>
              {customer.phone && <div className="customer-phone">📞 {customer.phone}</div>}
            </div>
            <div className="customer-balance">
              <span className="balance-label">Outstanding</span>
              <span className={`balance-value ${customer.outstandingBalance > 0 ? 'negative' : 'zero'}`}>
                RM {customer.outstandingBalance?.toFixed(2) || '0.00'}
              </span>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}

export default Customers;
